
































































































































































































































































































































































































































































































































































































































































































































































































































import { Component, Prop, Ref, Vue, Watch } from 'vue-property-decorator';
import { NotificationEventBus } from '@/EventBus';
import ImagePicker from '@/components/common/ImagePicker.vue';
import FileSelector from '@/components/common/FileSelector.vue';
import { getModule } from 'vuex-module-decorators';

import Decisions from '@/store/modules/Decisions';
import Choices, { Choice } from '@/store/modules/Choices';
import Sticky from 'vue-sticky-directive';
import { Urls } from '@/Urls';
import Modelling from '@/store/modules/Modelling';
import Navigation from "@/store/modules/Navigation";
import { FactorResource } from '@/api/model/FactorResource';
import { FactorGroup } from '@/api/model/FactorResource';
import { VIEWPOINT_API } from '@/api/ViewpointApi';
import SignUpDialog from '@/views/Auth/SignUpDialog.vue';
import CardFactorNavigationPanel from '@/views/ChoiceCards/ChoiceCardFactorNavigationPanel.vue';
import ChoiceCardFactorInput from '@/components/choice-input/ChoiceFactorInput.vue';
import ChoiceCardGrowingTableInput from '@/views/ChoiceSubmitter/ChoiceSubmitterGrowingTable.vue';
import ChoiceCardFixedTableInput from '@/views/ChoiceSubmitter/ChoiceSubmitterFixedTable.vue';
import WorkspaceOptions from '@/store/modules/WorkspaceOptions';
import Viewpoints from '@/store/modules/Viewpoints';
import ConfirmationDialog from '@/components/common/ConfirmationDialog.vue';
import ResultsEmbed from '@/views/ChoiceViewpointsScorer/ResultsEmbed.vue';
import _ from 'lodash';
import ChoiceCardDialog from '@/views/ChoiceCards/ChoiceCardDialog.vue';
import Users from '@/store/modules/Users';
import { UserManagementDao } from '@/api/UserManagementDao';
import LinkShareDialog from '@/components/common/LinkShareDialog.vue';
import CommentBadge from "@/components/comments/CommentBadge.vue";
import { ResourceType } from "@/store/modules/Comments";
import Apps from '@/store/modules/Apps';
import CreateChoiceDialog from '@/views/ChoiceCards/CreateChoiceDialog.vue';
import BasicInputForm from '@/components/forms/BasicInputForm.vue';
import ChoiceSelectCommon from '@/components/common/ChoiceSelectCommon.vue'
import CardTitle from '@/components/common/CardTitle.vue';

const modellingModule = getModule(Modelling);
const navigationModule = getModule(Navigation);
const decisionsModule = getModule(Decisions);
const choicesModule = getModule(Choices);
const workspaceOptionsModule = getModule(WorkspaceOptions);
const viewpointsModule = getModule(Viewpoints);
const usersModule = getModule(Users);
const appsModule = getModule(Apps);

@Component({
    name: 'ChoiceCard',
    components: {
        ImagePicker,
        FileSelector,
        CardFactorNavigationPanel,
        ChoiceCardFactorInput,
        ChoiceCardGrowingTableInput,
        ChoiceCardFixedTableInput,
        ConfirmationDialog,
        ChoiceCardDialog,
        ResultsEmbed,
        SignUpDialog,
        LinkShareDialog,
        CommentBadge,
        CreateChoiceDialog,
        BasicInputForm,
        CardTitle,
        ChoiceSelectCommon
    },
    directives: {
        Sticky,
    },
})
export default class ChoiceCard extends Vue {

    @Prop({ type: Boolean, default: false })
    embed!: boolean;

    @Prop({ type: String })
    choiceName!: string;

    @Prop({ type: Object })
    userDetails!: any;

    @Prop({ default: false, type: Boolean })
    appEmbed: boolean;

    @Prop({ type: Boolean, default: false })
    autofill!: boolean;

    @Prop({type: Boolean, default: false})
    createChoice!: boolean

    @Prop({ default: false, type: Boolean })
    heroActive!: boolean

    verificationRules: any = {
        length: (value: any) => ( !!value && value.length == 36 || 'Must be a 36 character Verification Code')
    };

    verificationCodeValue: string | null = null;
    verificationError = false;
    verifyOpen = true;
    private verificationCode = false;
    private submitted = false;
    private cleanChoiceForm: any = {};
    private disabled = false;
    private readonly URLS = Urls;
    loading = false;
    valid = true;
    choiceForm: any = {};
    submissionId: any = null;
    submitting = false;
    convertError = false;
    requiredRule = [(v: string) => !!v || 'Field is required'];
    private step = 0;
    private menu = false;
    private unsavedChanges = false;
    private collapseNavigation = false;
    private dialog = false;
    private requiredEndDialog = true;
    private testField: any = null;
    private createChoiceDialog = false;
    private selectChoiceMenu = false;
    private createViewpointDialog = false;
    private submitConfirmation = false;
    private previousQuestionPosition = 0;

    @Ref()
    form!: HTMLFormElement;
    
    @Ref()
    card!: HTMLDivElement;

    @Ref('verificationCodeField')
    verificationCodeField!: HTMLInputElement;
    
    submitCode() {
        if (this.verificationCodeValue === this.selectedChoiceId) {
            this.verifyOpen = false;
        } else {
            this.verificationError = true;
            setTimeout( () => { this.verificationError = false }, 3000 );
        }
    }
    // beforeCreate(){
    //     this.$options.components.ChoiceCardDialog = require('./ChoiceCardDialog.vue');
    // }

    mounted() {
        // setTimeout( ()=>{ this.init() }, 500 );
        this.init();
        setTimeout( () => {
            // // OLD vanilla VueJS
            // this.$refs.nameField.focus();

            // NEW Vue Decorator Class style VueJS
            this.verificationCodeField.focus();
        }, 500);
    }

    get hostname() {
        return window.location.hostname;
    }

    private async init() {
        if ( this.selectedChoice && this.selectedChoice.hasOwnProperty('id') && !this.createChoiceDialog ) {
            this.choiceForm = Object.assign({}, this.selectedChoice);
            this.submissionId = this.selectedChoice.id;
        }
        this.cleanChoiceForm = _.cloneDeep(this.choiceForm);
        if (this.autofill && this.guestName && !this.createChoiceDialog) {
            Vue.set(this.choiceForm, 'name', this.guestName);
            let res = await this.saveChoice();
        } 
        if (this.embed && this.autofill && !this.createChoiceDialog) {
            this.stepUp();
            // setTimeout( ()=>{ this.stepUp() }, 500 );
            //setTimeout( ()=>{ this.saveChoice(), 600 } );
        }
    }

    private async createViewpoint(viewpoint: any) {
        if (!this.selectedDecision) return;
        let sampleViewpoint = _.cloneDeep(viewpoint);
        NotificationEventBus.emitProcessingMessage();
        this.createViewpointDialog = false;
        try {
            let res = await decisionsModule.createDecisionViewpoint({
                decisionId: this.selectedDecision.decisionId,
                name: viewpoint.name,
                description: viewpoint.description
            });
            if (
                sampleViewpoint.addToList &&
                this.activeViewpointList?.length > 0 
                // && this.addToList
            ) {
                decisionsModule.addViewpointToActiveLists(res.viewpointId);
            }
            NotificationEventBus.emitSuccessMessage();
        } catch (err) {
            NotificationEventBus.emitFailedMessage(err);
        }
    }

    get editContent() {
        return workspaceOptionsModule.editContent;
    }

    get selectionMenu() {
        return appsModule.selectionMenu;
    }

    get activeViewpointList() {
        return workspaceOptionsModule.activeViewpointLists;
    }

    get isOwnerOrAdmin() {
        return decisionsModule.isAdminOrOwner;
    }

    get singularViewpointLabel() {
        return decisionsModule.singularViewpointLabel;
    }

    get pluralViewpointLabel() {
        return decisionsModule.pluralViewpointLabel;
    }

    get commentBottomHeight(){
        return workspaceOptionsModule.commentBottomHeight;
    }
    
    get commentVertical() {
        return workspaceOptionsModule.commentVertical;
    }

    get pinnedRight() {
        return workspaceOptionsModule.pinnedRight;
    }

    get appMenuName(){
        return appsModule.activeAppMenuName;
    }

    get cardContainerSize() {
        let commentHeight = 0;
        if (this.commentVertical && this.pinnedRight) {
            commentHeight = this.commentBottomHeight;
        } else if (!this.pinnedRight && this.appEmbed) {
            commentHeight = 40;
        } else {
            commentHeight = 0;
        }

        if (this.appEmbed) {
            if (this.heroActive) {
                return `min-height: calc(100vh - 258px - ${commentHeight}px); max-height: calc(100vh - 258px - ${commentHeight}px);`;
            } else {
                return `min-height: calc(100vh - 146px - ${commentHeight}px); max-height: calc(100vh - 146px - ${commentHeight}px);`;
            }
        } else if (this.embed) {
             return `max-height : calc(100vh - ${commentHeight}px); min-height:calc(100vh - ${commentHeight}px)`;
        } else {
             return `max-height : calc(100vh - 230px - ${commentHeight}px); min-height:calc(100vh - 230px - ${commentHeight}px)`;
        }
    }

    get showChartTop() {
        return workspaceOptionsModule.chartTop;
    }

    get requiredEnd(): string {
        return navigationModule.requiredEnd;
    }

    get userId(): string {
        if (usersModule.currentUserProfile) {
            return usersModule.currentUserProfile.userId;
        }
        return '[user]';
    }

    get guestName() {
        return navigationModule.guestName;
    }

    get decisionAdminUsers(): string[] {
        if (!decisionsModule.selectedDecision) return ['[admins]'];
        return [decisionsModule.selectedDecision.ownerUserId];
    }

    get isAdmin(): boolean {
        return this.decisionAdminUsers.includes(this.userId);
    }

    get selectedDecision() {
        return decisionsModule.selectedDecision;
    }

    get selectedChoiceId() {
        return choicesModule.selectedChoiceId;
    }

    get selectedChoice() {
        return choicesModule.selectedChoice;
    }

    get selectedChoiceName() {
        return choicesModule.selectedChoice ? choicesModule.selectedChoice.name : '';
    }

    get singularChoiceLabel() {
        return decisionsModule.singularChoiceLabel
    }

    get pluralChoiceLabel() {
        return decisionsModule.pluralChoiceLabel;
    }

    get factorResources() {
        return modellingModule.publishedModelFactorResources;
    }

    get edit() {
        return this.selectedChoice != null;
    }

    get choicesList() {
        return choicesModule.choicesList;
    }

    get isDisabled(): boolean {
        return !this.choiceForm.name || false;
    }

    get factors() {
        return Object.values(modellingModule.publishedModelFactorResources);
    }

    get questionFactors() {
        return this.getQuestionFactorsSubSet(this.startingFactors);
    }

    get currentFactorId() {
        return workspaceOptionsModule.selectedPathItemId;
    }

    get contributingVisibility() {
        return workspaceOptionsModule.contributingFactorVisibility;
    }

    get contributingFactorResources() {
        return viewpointsModule.contributingFactorResources;
    }

    get descriptionVisibility() {
        return workspaceOptionsModule.descriptionVisibility;
    }

    get factorListTree() {
        return modellingModule.factorListTree;
    }

    get isFactorListActive() {
        return workspaceOptionsModule.activeFactorLists.length > 0;
    }

    get showNonListFactors() {
        return workspaceOptionsModule.showNonListFactors;
    }

    get commentsVisibility() {
        return workspaceOptionsModule.commentsVisibility
    }

    get resource() {
        return {
            id: 'Choice',
            name: `${this.selectedDecision.name}`,
            type: ResourceType.CHOICE
        }
    }

    get secondaryResource() {
        if (getModule(Choices).choices[this.choiceForm.id]) {
            return {
                id: this.choiceForm.id,
                type: ResourceType.CHOICE,
                name: getModule(Choices).choices[this.choiceForm.id].name
            }
        }
    }

    get editComments() {
        return workspaceOptionsModule.editComments;
    }

    private isFactorVisible(resourceId: string) {
        if (this.showNonListFactors || !this.isFactorListActive) {
            // return (
            //     this.contributingVisibility ||
            //     (!this.contributingVisibility && this.contributingFactorResources[resourceId])
            // );
            return true;
        } else {
            if (
                this.isFactorListActive &&
                this.factorListTree[resourceId] &&
                !this.showNonListFactors
            ) {
                return true;
            } else return false;
        }
    }

    get isViewpointActive() {
        return viewpointsModule.activeViewpointId != null;
    }

    get skipGroups() {
        return workspaceOptionsModule.skipGroups;
    }

    get previousChoice() {
        let index = this.choicesList.indexOf(this.selectedChoice);
        if (index > 0 && this.choicesList.length > 1) {
            return this.choicesList[index - 1].name;
        }

        if (index === 0 && this.choicesList.length > 1) {
            return this.choicesList[this.choicesList.length - 1].name;
        }
    }

    get nextChoice() {
        let index = this.choicesList.indexOf(this.selectedChoice);
        if (index < this.choicesList.length - 1 && this.choicesList.length > 1) {
            return this.choicesList[index + 1].name;
        }

        if (index === this.choicesList.length - 1 && this.choicesList.length > 1) {
            return this.choicesList[0].name;
        }
    }

    set selectedChoice(choice: Choice) {
        choicesModule.selectChoice(choice.id);
        this.menu = false;
    }

    get startingFactors() {
        if(workspaceOptionsModule.trimTopGroups) {
            let topFactor = 'M'
            return this.getTopGroup('M');
        
        } else {
            return 'M';
        }
    }

    get choiceNavigation() {
        if (this.appEmbed) {
            console.log('Choice Selection: ' + appsModule.choiceSelectionMenu)
            return !appsModule.choiceSelectionMenu;
        }
        return true;
    }

    private submitChoice() {
        this.submitConfirmation = true;
        this.updateSelectedFactor();
        if (this.card) {
            //console.log(this.card);
            this.card.scrollTop = 0;
        }
        if (this.unsavedChanges) {
            this.saveChoice();
        }
    }

    private getTopGroup(topId: string) {
        if(!workspaceOptionsModule.trimTopGroups) {
            return topId;
        }

        if(this.factorResources[topId].childrenIds.length != 1 ? true: this.factorResources[this.factorResources[topId].childrenIds[0]].type != 'FACTOR_GROUP') {
            return topId;
        }

        if('groupTypeDefinition' in this.factorResources[this.factorResources[topId].childrenIds[0]]) {
            return topId
        }

        if(this.factorResources[topId].childrenIds.length === 1) {
            return this.getTopGroup(this.factorResources[topId].childrenIds[0]);
        }
    }

    private selectFactorResource(val: string = '') {
        if(val) {
            workspaceOptionsModule.selectBreadcrumbItem(val);
            workspaceOptionsModule.updateExpansions(val);
        }
    }

    private stepForm(val: string = '') {
        this.card.scrollTop = 0;
        const questions = this.questionFactors;
        if (val && questions) {
            this.previousQuestionPosition = 0;
            const questionIndex: number = questions.findIndex((value) => value.id === val);
            this.step = questionIndex + 1;
        } else {
            this.previousQuestionPosition = this.step;
            this.step = this.questionFactors.length + 1;
        }
        // if (this.unsavedChanges) this.saveChoice();
    }

    private stepUp() {
        this.step++;
        this.updateSelectedFactor();
        if (this.card) {
            //console.log(this.card);
            this.card.scrollTop = 0;
        }
        // if (this.unsavedChanges) this.saveChoice();
    }

    private stepDown() {
        if (this.previousQuestionPosition) {
            this.step = this.previousQuestionPosition;
        } else {
            this.step--;
        }
        this.updateSelectedFactor();
        if (this.card) {
            //console.log(this.card);
            this.card.scrollTop = 0;
        }
        // if (this.unsavedChanges) this.saveChoice();
    }

    private updateSelectedFactor () {
        if (this.step > 0 && this.factors) {
            if (this.questionFactors[this.step - 1]) {
                 this.selectFactorResource(this.questionFactors[this.step - 1].id);
            }
        }
    }

    get activeChoiceLists() {
        return workspaceOptionsModule.activeChoiceLists
    }

    private async imageChange() {
        if (this.choiceForm && this.submissionId) {
            this.submitting = true;
            NotificationEventBus.emitProcessingMessage();
            try {
                await choicesModule.updateChoiceImage({
                    choiceId: this.choiceForm.id,
                    image: this.choiceForm.image,
                });
                NotificationEventBus.emitSuccessMessage();
            } catch (err) {
                NotificationEventBus.emitFailedMessage(err);
            }
            this.submitting = false;
        }
    }

    private start() {
        this.step++;
    }

    async saveChoice() {
        if (this.form && !this.form.validate()) {
            console.error('Invalid Data');
            return;
        }
        this.submitting = true;
        var res: any;
        NotificationEventBus.emitProcessingMessage();
        if (this.choiceForm && this.submissionId) {
            res = await choicesModule
                .updateChoice({ choice: this.choiceForm, refreshScoring: true })
                .then(() => {
                    NotificationEventBus.emitSuccessMessage();
                    this.submitting = false;
                    this.submitted = true;
                    this.unsavedChanges = false;
                })
                .catch((err) => {
                    this.submitting = false;
                    NotificationEventBus.emitFailedMessage(err);
                });
        } else {
            if ( Object.keys(this.choiceForm).length > 0 && !this.submissionId ) {
                console.log( Object.keys(this.choiceForm) + ' : ' + Object.values(this.choiceForm));
                let res = await choicesModule
                    .createChoice(this.choiceForm)
                    .then((result) => {
                        console.log('saveChoice() > createChoice Result');
                        console.log(result);
                        this.submitting = false;
                        choicesModule.setSelectedChoiceId(result.id);
                        if(this.activeChoiceLists?.length > 0) {
                            decisionsModule.addChoiceToActiveLists(result.id);
                            choicesModule.fetchChoices();
                        }
                        NotificationEventBus.emitSuccessMessage();
                        NotificationEventBus.emitStaleSandboxScoringData('');
                        // SEND EMAIL VERIFICATION CODE & LINK
                        // { userId: string, email: string, choiceId: string, link: string, adminEmail: string, userDetails: string }
                        let userDetails = JSON.stringify(this.userDetails);
                        let userDetailsText = this.formatUserDetailsText(this.userDetails);
                        let userDetailsHtml = this.formatUserDetailsHtml(this.userDetails);
                        console.log('saveChoice() > userDetails');
                        console.log(userDetails);
                        console.log('saveChoice() > userDetailsText');
                        console.log(userDetailsText);
                        console.log('saveChoice() > userDetailsHtml');
                        console.log(userDetailsHtml);
                        decisionsModule.sendChoiceSubmissionEmail({decisionId: this.selectedDecision.decisionId, userId: '', email: this.choiceName, choiceId: this.selectedChoiceId, link: 'https://viewpoint-ai.com', adminEmail: 'ddifelice@viewpoint.ai', userDetails: userDetailsText, userDetailsHtml: userDetailsHtml, linkText: 'Viewpoint AI' });
                        this.submitted = true;
                        this.unsavedChanges = false;
                    })
                    .catch((err) => {
                        this.submitting = false;
                        NotificationEventBus.emitFailedMessage(err);
                    });
                this.submitted = true;
            }
        }
        return res;
    }

    formatUserDetailsText(userDetails: any) {
        let res: string = '';
        if (userDetails.name) { res += 'Email Address: ' + userDetails.name + '\r\n' }
        if (userDetails.company) { res += 'Company: ' + userDetails.company + '\r\n' }
        if (userDetails.companyPhone) { res += 'Company Phone: ' + userDetails.companyPhone + '\r\n' }
        if (userDetails.website) { res += 'Website: ' + userDetails.website + '\r\n' }
        if (userDetails.industry) { res += 'Industry: ' + userDetails.industry + '\r\n' }
        if (userDetails.contactName1) { res += 'First Name: ' + userDetails.contactName1 + '\r\n' }
        if (userDetails.contactName2) { res += 'Last Name: ' + userDetails.contactName2 + '\r\n' }
        if (userDetails.contactJobTitle) { res += 'Job Title: ' + userDetails.contactJobTitle + '\r\n' }
        if (userDetails.contactPhone) { res += 'Phone: ' + userDetails.contactPhone + '\r\n' }
        return res;
    }

    formatUserDetailsHtml(userDetails: any) {
        let res: string = '<div style="text-align:left">';
        if (userDetails.name) { res +=            '<div><span style="display: inline-block; width: 140px">' + 'Email Address: ' + '</span><span style="display: inline-block; width: 180px">' + userDetails.name +            '</span></div>' }
        if (userDetails.company) { res +=         '<div><span style="display: inline-block; width: 140px">' + 'Company: '       + '</span><span style="display: inline-block; width: 180px">' + userDetails.company +         '</span></div>' }
        if (userDetails.companyPhone) { res +=    '<div><span style="display: inline-block; width: 140px">' + 'Company Phone: ' + '</span><span style="display: inline-block; width: 180px">' + userDetails.companyPhone +    '</span></div>' }
        if (userDetails.website) { res +=         '<div><span style="display: inline-block; width: 140px">' + 'Website: '       + '</span><span style="display: inline-block; width: 180px">' + userDetails.website +         '</span></div>' }
        if (userDetails.industry) { res +=        '<div><span style="display: inline-block; width: 140px">' + 'Industry: '      + '</span><span style="display: inline-block; width: 180px">' + userDetails.industry +        '</span></div>' }
        if (userDetails.contactName1) { res +=    '<div><span style="display: inline-block; width: 140px">' + 'First Name: '    + '</span><span style="display: inline-block; width: 180px">' + userDetails.contactName1 +    '</span></div>' }
        if (userDetails.contactName2) { res +=    '<div><span style="display: inline-block; width: 140px">' + 'Last Name: '     + '</span><span style="display: inline-block; width: 180px">' + userDetails.contactName2 +    '</span></div>' }
        if (userDetails.contactJobTitle) { res += '<div><span style="display: inline-block; width: 140px">' + 'Job Title: '     + '</span><span style="display: inline-block; width: 180px">' + userDetails.contactJobTitle + '</span></div>' }
        if (userDetails.contactPhone) { res +=    '<div><span style="display: inline-block; width: 140px">' + 'Phone: '         + '</span><span style="display: inline-block; width: 180px">' + userDetails.contactPhone +    '</span></div>' }
        res += '</div>';
        return res;
    }

    //This is used for the start new dialog - creates a new choice with name from CreateChoiceDialog
    saveChoiceName(choiceName: string) {
        this.submitting = true;
        NotificationEventBus.emitProcessingMessage();
        if (choiceName != '') {
            this.choiceForm = {};
            let newChoice: any = {name: choiceName}
            choicesModule
                .createChoice(newChoice)
                .then((result) => {
                    console.log('saveChoiceName > createChoice Result');
                    console.log(result);
                    this.submitting = false;
                    choicesModule.selectChoice(result.id);
                    if(this.activeChoiceLists?.length > 0) {
                        decisionsModule.addChoiceToActiveLists(result.id);
                        choicesModule.fetchChoices();
                    }
                    NotificationEventBus.emitSuccessMessage();
                    NotificationEventBus.emitStaleSandboxScoringData('');
                    this.submitted = true;
                    this.unsavedChanges = false;
                })
                .catch((err) => {
                    this.submitting = false;
                    NotificationEventBus.emitFailedMessage(err);
                });
            this.createChoiceDialog = false;
            this.submitted = true;
        }
    }

    @Watch('selectedChoice')
    private choiceSelected() {
        if ( this.selectedChoice && this.selectedChoice.hasOwnProperty('id') ) {
            this.choiceForm = Object.assign({}, this.selectedChoice);
            this.submissionId = this.selectedChoice.id;
            this.cleanChoiceForm = _.cloneDeep(this.choiceForm);
            this.unsavedChanges = false;
        } else {
            this.resetVars();
        }
    }

    @Watch('currentFactorId')
    private onFactorIdChanged() {
        this.stepForm(this.currentFactorId);
        this.selectFactorResource(this.currentFactorId);
    }

    private createNewChoice() {
       // this.cleanChoiceForm = {};
        //choicesModule.selectChoice(null);
        this.createChoiceDialog = true;
        this.unsavedChanges = false;
    }

    private rules = {
        required: (value: string) => !!value || 'Required',
    };

    private navigateToChoiceUpdate() {
        if (this.$router.currentRoute.path !== Urls.CHOICE_SUBMITTER) {
            this.$router.push(Urls.CHOICE_SUBMITTER);
        }
    }

    private resetVars() {
        this.submitting = false;
        this.submitted = false;
        this.choiceForm = {};
        this.cleanChoiceForm = {};
        this.submissionId = null;
        this.valid = true;
        this.step = 0;
        if (this.form) {
            this.form.reset();
        }
    }

    private getQuestionFactorsSubSet(groupId: string) {
        let subQuestionFactorList: any[] = [];
        let factorGroup: FactorGroup = this.factorResources[groupId] as FactorGroup;
        if (!factorGroup) {
            return [];
        }
        let children = this.factorResources[this.getTopGroup(factorGroup.id)].childrenIds
            .map((id) => this.factorResources[id])
            .filter((f) => this.isFactorVisible(f.id));

        children.forEach((child: FactorResource) => {
            if (!this.skipGroups) subQuestionFactorList.push(child);

            if (
                child.type === 'FACTOR_GROUP' &&
                (!(child as FactorGroup).groupTypeDefinition ||
                    !(child as FactorGroup).groupTypeDefinition.type.startsWith('TABLE'))
            ) {
                subQuestionFactorList = subQuestionFactorList.concat(
                    this.getQuestionFactorsSubSet(child.id)
                );
            } else if (this.skipGroups) {
                subQuestionFactorList.push(child);
            }
        });
        return subQuestionFactorList;
    }

    private findParent(searchId: string, currentId: string): FactorGroup | undefined {
        let factorResource = this.factorResources[currentId];
        if (factorResource.type === 'FACTOR_GROUP') {
            if ((factorResource as FactorGroup).childrenIds.includes(searchId)) {
                return this.factorResources[currentId] as FactorGroup;
            }
            for (let childId of (factorResource as FactorGroup).childrenIds) {
                let subsearch = this.findParent(searchId, childId);
                if (subsearch) {
                    return subsearch;
                }
            }
        }
    }

    //@Watch('skipGroups')
    private onChangeSkipGroups(val: any) {
        if (this.step >= this.questionFactors.length) {
            this.step = this.questionFactors.length;
        }
    }

    private cycleLeft() {
        let index = this.choicesList.indexOf(this.selectedChoice);
        if (index > 0) {
            choicesModule.selectChoice(this.choicesList[index - 1].id);
        }

        if (index === 0) {
            choicesModule.selectChoice(this.choicesList[this.choicesList.length - 1].id);
        }
    }

    private cycleRight() {
        let index = this.choicesList.indexOf(this.selectedChoice);
        if (index < this.choicesList.length - 1) {
            choicesModule.selectChoice(this.choicesList[index + 1].id);
        }

        if (index === this.choicesList.length - 1) {
            choicesModule.selectChoice(this.choicesList[0].id);
        }
    }

    @Watch('choiceForm', { deep: true })
    onChangeChoiceForm(newVal: any, oldVal: any) {
        // console.log(this.questionFactors)
        if (!_.isEqual(newVal, this.cleanChoiceForm)) {
            // console.log(this.unsavedChanges)
            this.unsavedChanges = true;
        }
    }

    get editPermissions() {
        return getModule(Choices).checkChoiceEditPermissions
    }
}
